import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../../components/NtText";
import NtSectionTitle from "../general/NtSectionTitle";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";

function NtHospitalityFeatureSection({}) {
  const renderBox = (icon, text, containerStyle) => {
    return (
      <View
        style={[
          {
            borderWidth: 1,
            borderColor: "#2c4d7a",
            backgroundColor: "#050f1d",
            borderRadius: 15,
            alignItems: "center",
            padding: 30,
          },
          containerStyle,
        ]}
      >
        <NtMaterialIcon name={icon} size={30} color="#006AFF" />

        <NtText
          style={{
            color: "white",
            fontSize: 15,
            fontWeight: "600",
            marginTop: 8,
            textAlign: "center",
          }}
        >
          {text}
        </NtText>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View
        style={{
          width: "100%",
        }}
      >
        <NtSectionTitle>FEATURES</NtSectionTitle>

        <View style={{ flexDirection: "row", marginTop: 30 }}>
          {renderBox("arrow-expand-all", "Easy Scalable", {
            flex: 1,
            marginRight: 10,
          })}
          {renderBox("tools", "Easy to Maintain", {
            flex: 1,
            marginRight: 10,
          })}
          {renderBox("rocket-launch", "Easy to Launch", { flex: 1 })}
        </View>
        <View style={{ flexDirection: "row", marginTop: 10 }}>
          {renderBox("cellphone-sound", "Walkie Talkie", {
            flex: 1,
            marginRight: 10,
          })}
          {renderBox("message", "Messaging", {
            flex: 1,
            marginRight: 10,
          })}
          {renderBox("video", "Video Calling", { flex: 1 })}
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtHospitalityFeatureSection;
